import DashboardPage from "~/pages/DashboardPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/dashboard")({
  component: DashboardPage,
});
